import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import TopNavigation from '../Components/navigation/TopNavigation'
import MainFooter from '../Components/footer/MainFooter'
import { useSelector } from 'react-redux';
import axios from 'axios';
import * as CONSTANTS from "./../CONSTANTS";
import { toast } from 'react-toastify';

function RefundsTerminate() {
    const {user}                                                        = useSelector((state) => state.auth);
    const [processing, setProcessing]                                   = useState(false);

    const [formData, setFormData]           = useState({
            full_name: '',
            emailAddress: '',
            reason: '',
            userId: user?._id
       });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleTermination = async (e) => {
        e.preventDefault();
        try{

            console.log(formData);
            setProcessing(true);
            const resData = await axios.post(CONSTANTS.API_URL + 'settings/termination/v1/request', formData, {
                    headers: {
                      token: 'Bearer ' + user.accessToken,
                    },
                  }
                );
                
           // console.log(resData);
            toast.success(resData.data.message);
            setProcessing(false);
            setFormData({
                full_name: '',
                emailAddress: '',
                reason: '',
                userId: user?._id
            });
        }catch(err){
            console.log(err);
            toast.warning("Something went wrong. Please try again later.");
            setProcessing(false);
        }
    }

  return (
    <div className="main-layer">
        <Helmet>
          <title>Lovedripp - Refunds & Termination </title>
        </Helmet>
       <TopNavigation title={"Refunds & Termination "} classBack="full-white"/>
       
            <div className="container">
                <div className="section-item terms-pop">
                <h2>Refund Policy</h2>
                    <p>
                    Lovedripp does <strong>not offer refunds</strong> for users who choose to delete their accounts.
                    </p>
                    <p>
                    However, for digital or physical products owned and sold directly by Lovedripp, a <strong>50% refund</strong> may be granted if a reasonable request is submitted within <strong>30 days</strong> of the original purchase date.
                    </p>
                    <p>
                    Refund requests must include proof of purchase and a clear explanation of the issue. Refund decisions are made at the discretion of the Lovedripp team.
                    </p>
                </div>

                <div className="section-item-prt mgbot60">
                    <h2>Request Account Termination</h2>      
                    {
                        user ? (
                            <div className="term-box">
                                <p>
                                If you wish to permanently delete your account from Lovedripp, please fill out the form below. This action is irreversible.
                                </p>
                                 <form onSubmit={handleTermination} className="termination-form">
                                    <div className="form-group mgtop10">
                                        <label className="form-label">Full Name*</label>
                                        <input type="text" className="form-control"
                                            name="full_name" 
                                            value={formData.full_name} 
                                            onChange={handleChange}
                                            required />
                                    </div>

                                    <div className="form-group mgtop10">
                                        <label className="form-label">Email Address*</label>
                                        <input type="email" className="form-control" 
                                            name="emailAddress" 
                                            value={formData.emailAddress} 
                                            onChange={handleChange}
                                            required />
                                    </div>

                                    <div className="form-group mgtop10">
                                        <label className="form-label">Reason for Termination</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="4"
                                            name="reason" 
                                            value={formData.reason} 
                                            onChange={handleChange}required></textarea>
                                    </div>

                                    <div className="form-group mgtop10">
                                        <button
                                            disabled={processing} 
                                            type="submit" 
                                            className="btn btn-danger">Submit Termination Request</button>
                                    </div>
                                    </form>
                            </div>
                        )
                        :
                        <div className="term-box">
                            <h5>Please login, in order to request for your account to terminated.</h5>
                        </div>
                    }
                   
                </div>
            </div>
            {
                processing && (
                    <div className="processing-spinner">
                            <img src={CONSTANTS.SMALL_PROCESSING} className="pro-spin" />
                    </div>
                )
            }
       <MainFooter/>
    </div>
  )
}

export default RefundsTerminate